<template>
  <div class="wrap headerWrap">
    <el-row class="logoRow" type="flex" align="middle">
      <el-col :xs="12" :sm="19" :md="20">
        <el-row type="flex" align="middle">
          <router-link to="/"
            ><el-image
              src="logo.png"
              fit="contain"
              class="logo"
              @click="openNav(false)"
            ></el-image
          ></router-link>

          <el-menu
            :default-active="activeIndex"
            class="menuBox animate__animated"
            :class="{
              animate__slideInRight: showMenu,
              animate__slideOutRight: !showMenu,
            }"
            :mode="menuMode"
            background-color="#2a2a2a"
            text-color="#fff"
            active-text-color="#d71820"
            :router="true"
            v-show="showMenu"
            :unique-opened="true"
          >
            <el-menu-item index="/" @click="openNav(false)">
              <router-link to="/">首页</router-link></el-menu-item
            >

            <el-submenu index="1">
              <template slot="title">关于我们</template>
              <el-menu-item index="/about/my" @click="openNav(false)"
                >公司介绍</el-menu-item
              >
              <el-menu-item index="/culture" @click="openNav(false)"
                >企业文化</el-menu-item
              >
              <el-menu-item index="/leaders" @click="openNav(false)"
                >公司领导</el-menu-item
              >
              <el-menu-item index="/manager" @click="openNav(false)"
                >公司治理</el-menu-item
              >
              <el-menu-item index="/development" @click="openNav(false)"
                >发展历程</el-menu-item
              >
              <el-menu-item index="/honor" @click="openNav(false)"
                >荣誉信誉</el-menu-item
              >
              <el-menu-item index="/contact" @click="openNav(false)"
                >联系我们</el-menu-item
              >
            </el-submenu>

            <el-submenu index="2">
              <template slot="title">产品服务</template>
              <el-menu-item index="/product" @click="openNav(false)"
                >研发核心</el-menu-item
              >
              <el-menu-item
                index="/productIntroduce/top"
                @click="openNav(false)"
                >产品介绍</el-menu-item
              >
              <el-menu-item index="/quality" @click="openNav(false)"
                >管理体系认证</el-menu-item
              >
              <el-menu-item index="/assunce" @click="openNav(false)"
                >产品认证</el-menu-item
              >
              <el-menu-item index="/use/one" @click="openNav(false)"
                >应用领域</el-menu-item
              >
              <el-menu-item index="/use/three" @click="openNav(false)"
                >手册下载</el-menu-item
              >
              <el-menu-item index="/service" @click="openNav(false)"
                >检测服务</el-menu-item
              >
              <el-menu-item index="" @click="openNav(false)"
                ><a href="http://sys.zfsycf.com.cn:11180/" target="_blank"
                  >仪器管理系统</a
                ></el-menu-item
              >
            </el-submenu>

            <el-submenu index="4">
              <template slot="title">新闻中心</template>
              <el-menu-item index="/news/company" @click="openNav(false)"
                >公司动态</el-menu-item
              >
              <!--  <el-menu-item index="/news/culture" @click="openNav(false)"
                >文化活动</el-menu-item
              > -->
              <el-menu-item index="/news/video" @click="openNav(false)"
                >视频新闻</el-menu-item
              >
              <el-menu-item index="/news/industry" @click="openNav(false)"
                >行业动态</el-menu-item
              >
              <el-menu-item index="/news/infomation" @click="openNav(false)"
                >信息公示</el-menu-item
              >
              <el-menu-item index="/news/magazine" @click="openNav(false)"
                >企业内刊</el-menu-item
              >
            </el-submenu>

            <el-submenu index="5">
              <template slot="title"> 党的建设</template>
              <el-menu-item index="/party/important" @click="openNav(false)"
                >党建要闻</el-menu-item
              >
              <el-menu-item index="/party/foundation" @click="openNav(false)"
                >基层党建</el-menu-item
              >
              <el-menu-item index="/party/watch" @click="openNav(false)"
                >监督执纪</el-menu-item
              >
              <el-menu-item index="/party/team" @click="openNav(false)"
                >群团工作</el-menu-item
              >
            </el-submenu>

            <el-submenu index="3">
              <template slot="title">投资者关系</template>
              <el-menu-item index="/relationship/stock" @click="openNav(false)"
                >股票信息</el-menu-item
              >
              <el-menu-item index="/relationship/note" @click="openNav(false)"
                >公司公告</el-menu-item
              >

              <el-menu-item index="/responsibility" @click="openNav(false)"
                >社会责任</el-menu-item
              >
            </el-submenu>

            <el-submenu index="6">
              <template slot="title">人才资源</template>
              <el-menu-item index="/career" @click="openNav(false)"
                >人才理念</el-menu-item
              >
              <el-menu-item index="/careerNews/advanced" @click="openNav(false)"
                >先进典型</el-menu-item
              >
              <el-menu-item index="/careerNews/staff" @click="openNav(false)"
                >员工风采</el-menu-item
              >
              <el-menu-item index="/job" @click="openNav(false)"
                >人才招聘</el-menu-item
              >
              <el-menu-item index="/human" @click="openNav(false)"
                >人资动态</el-menu-item
              >
              <el-menu-item index="/talent" @click="openNav(false)"
                >人才政策</el-menu-item
              >
            </el-submenu>

            <!-- <el-menu-item index="3">招采平台</el-menu-item>
            <el-menu-item index="3">销售平台</el-menu-item> -->
          </el-menu>
        </el-row>
      </el-col>

      <el-col :xs="12" :sm="5" :md="4">
        <el-row type="flex" justify="end" align="middle" class="headerRight">
          <span class="headerS"
            ><router-link to="/search"
              ><i class="el-icon-search"></i></router-link
          ></span>
          <span class="lang">
            <em :class="{ on: lang == 'zh' }" @click="changeLang('zh')">CN</em>
            /
            <em :class="{ on: lang == 'en' }" @click="changeLang('en')"
              >EN</em
            >
          </span>
          <!-- <span>股票代码 <br />600000</span> -->
          <div class="navBox">
            <svg
              @click="openNav(true)"
              v-if="showNav"
              data-v-c569994e=""
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="2"
                y="4"
                width="20"
                height="1"
                stroke="currentColor"
                stroke-linecap="square"
              ></rect>
              <rect
                x="2"
                y="11"
                width="20"
                height="1"
                stroke="currentColor"
                stroke-linecap="square"
              ></rect>
              <rect
                x="2"
                y="18"
                width="20"
                height="1"
                stroke="currentColor"
                stroke-linecap="square"
              ></rect>
            </svg>
            <svg
              v-else
              @click="openNav(false)"
              data-v-c569994e=""
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.6366 11.7784L19.7077 4.70735L19.0006 4.00024L11.9295 11.0713L4.85847 4.00024L4.15137 4.70735L11.2224 11.7784L4.15137 18.8495L4.85847 19.5566L11.9295 12.4855L19.0006 19.5566L19.7077 18.8495L12.6366 11.7784Z"
                stroke="currentColor"
                stroke-linecap="square"
              ></path>
            </svg>
          </div>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { judgeWindow } from "@/utils/tool.js";

export default {
  data() {
    return {
      activeIndex: this.$route.path || "",
      showNav: true,
      menuMode: "horizontal",
      showMenu: true,
      screenWidth: document.body.clientWidth,
      lang: this.$global.lang,
    };
  },
  methods: {
    openNav(boo) {
      if (judgeWindow()) {
        this.menuMode = "vertical";
        this.showNav = !boo;
        this.showMenu = boo;
      }
    },
    changeW() {
      if (judgeWindow()) {
        this.showMenu = false;
      } else {
        this.showMenu = true;
      }
    },
    changeLang(value) {
      const includedRoutes = [
        "/",
        "/about/my",
        "/about/culture",
        "/leaders",
        "/development",
        "/developmentplan",
        "/productIntroduce/top",
        "/productIntroduce/two",
        "/use/one",
        "/honor",
        "/news/company",
        "/contact",
        "/search",
      ];
      const path = window.location.hash.replace("#", "");
      console.log(path, "++++++++++++++++++changeLang");
      if (value == "en" && !includedRoutes.includes(path)) {
        this.$global.changeLang(value);
        this.$router.push("/");
        sessionStorage.setItem("reload", JSON.stringify(1));
        return;
      }

      const open = sessionStorage.getItem("openState");
      if (open == "false") {
        this.$global.changeLang(value);
        this.$router.push("/");
        location.reload();
      }
    },
  },
  created() {
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        // 对路由变化做出响应...
        this.activeIndex = this.$route.path;
      }
    );
  },
  /*   watch: {
    screenWidth(val) {
      console.log("val", val);
      this.screenWidth = val;
    },
  }, */
  watch: {
    screenWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          // 打印screenWidth变化的值
          that.timer = false;
        }, 400);
      }
    },
  },
  mounted() {
    this.activeIndex = this.$route.path;
    this.changeW();

    window.onresize = () => {
      this.changeW();
    };
  },
};
</script>

<style lang="scss">
.headerWrap {
  min-height: 60px;
  .lang {
    em {
      cursor: pointer;
    }
  }
  .animate__animated.animate__slideInRight,
  .animate__animated.animate__slideOutRight {
    --animate-duration: 0.2s;
  }
  .el-menu--collapse .el-menu .el-submenu,
  .el-submenu__title i {
    display: none !important;
  }
  .el-menu-item.is-active {
    color: #fff !important;
    font-weight: bold;
  }
  .is-active {
    .el-submenu__title {
      color: #fff !important;
      font-weight: bold;
    }
  }
  .el-carousel__button {
    width: 40px;
    height: 4px;
  }
  .el-submenu__title:hover {
    font-size: bold;
  }
  .el-menu--horizontal > .el-submenu:focus,
  .el-menu--horizontal > .el-submenu:hover {
    font-weight: bold;
  }
  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    font-weight: bold;
  }
}
.el-menu--popup {
  min-width: 95px !important;
}
.el-menu--popup-bottom-start {
  margin-top: 0 !important;
}
.navBox {
  text-align: right;
  display: none;
}
.navMask {
  position: fixed;
  left: 0;
  right: 0;
  top: 60px;
  bottom: 0;
  background: #fff;
}
</style>
